export default function MapSkeleton(): JSX.Element {
  return <div role="status" className="h-full min-h-[256px] w-full animate-pulse rounded-sm bg-neutral-30 shadow-2" />;
}
